import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerticalMenuComponent } from './vertical-menu.component';
import { SharedModule } from '../../shared/shared.module';
import { IconsModule } from '../../icons/icons.module';



@NgModule({
  declarations: [
    VerticalMenuComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

    IconsModule,
  ],
  exports: [
    VerticalMenuComponent
  ],
})
export class VerticalMenuModule { }
